function coordinations(state = {}, action) {
    switch(action.type) {
        case 'COORDINATIONS_FETCH_START':
            return {
                data : {},
                fetching : true,
                error : null,
            }
        case 'COORDINATIONS_FETCH_SUCCESS':
            return {
                data : action.data,
                fetching : false,
                error : null,
            }
        case 'COORDINATIONS_FETCH_FAILURE':
            return {
                data : {},
                fetching : false,
                error : action.error,   
            }
        default :
            return state;        
    }
}


export default coordinations;


/** WEBPACK FOOTER **
 ** ./src/reducers/coordinations.js
 **/